<template>
  <section class="modals">
    <section-title>Modal Component</section-title>
    <button-input @click.prevent="$refs.modal.show()">
      Open Modal
    </button-input>

    <modal
      ref="modal"
      title="Create new team"
    >
      <form-wrap>
        <form-field-set :should-show-border="false">
          <text-input
            v-model="teamName"
            direction="vertical"
            label="Name of team"
            name="team-name"
          />
          <switch-input
            v-model="isTeamPublic"
            label="The team site is publicit visible"
            name="team-public"
          />
          <text-area-input
            v-model="textarea"
            direction="vertical"
            name="randomTextArea"
          />
        </form-field-set>

        <form-actions>
          <button-input>
            Create team
          </button-input>
          <a
            class="cancel"
            @click="$refs.modal.close()"
          >
            Cancel
          </a>
        </form-actions>
      </form-wrap>
    </modal>

  </section>
</template>

<script>
import FormMixin from '@/mixins/forms/Form'
import Modal from '@/components/ui/Modal'
import SectionTitle from '@/components/ui/SectionTitle'

export default {
  name: 'Modals',
  mixins: [FormMixin],
  components: {
    Modal,
    SectionTitle
  },
  data () {
    return {
      isTeamPublic: false,
      teamName: '',
      textarea: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/playground/Modals.vue